import { useMatch, useResolvedPath } from 'react-router-dom';

import { globalTheme, useMixin } from '@clds/component-theme';
import { NavigationMenuItem } from '@cld-remote/application_wrapper/index';

export interface SideMenuLinkProps {
  activeOnPath: 'exact-only' | 'exact-and-subpaths';
  children?: React.ReactNode;
  rightSlot?: React.ReactNode;
  leftSlot?: React.ReactNode;
  to: string;
  onClick?: () => void;
}

const matchPath = (activeOnPath: SideMenuLinkProps['activeOnPath'], currentPath: string, matchWith: string) => {
  switch (activeOnPath) {
    case 'exact-and-subpaths':
      return currentPath.startsWith(matchWith);

    case 'exact-only':
      return currentPath === matchWith;
  }
};

export const useMenuLinkSelection = ({ to, activeOnPath }: { to: string; activeOnPath: SideMenuLinkProps['activeOnPath'] }): { isSelected: boolean } => {
  const { pathname } = useResolvedPath('');
  const match = useMatch(`${pathname}/*`);
  const isSelected = !!to && !!match?.params['*'] && matchPath(activeOnPath, match?.params['*'], to);

  return { isSelected };
};

export const SideMenuLink = ({ activeOnPath = 'exact-and-subpaths', to, ...props }: SideMenuLinkProps) => {
  const { isSelected } = useMenuLinkSelection({ to, activeOnPath });
  const spacing = useMixin(globalTheme.spacing);
  const paddingRight = spacing.xs;
  const paddingLeft = props.leftSlot ? spacing.sm : undefined;

  return <NavigationMenuItem linkProps={{ href: to, style: { paddingRight, paddingLeft } }} isSelected={isSelected} {...props} />;
};
